import { ApiClients } from '@roolz/api/clients'
import {
  CheckNicknameBusynessRequest,
  CheckNicknameBusynessResponse,
  ClientConfigResponse,
  SendSmsRequest,
  SendSmsResponse,
  SendSmsToChangePhoneRequest, SendSmsToChangePhoneResponse
} from '@roolz/types/api/profiles'
import { PointsTimezonesResponse, SendEventRequest } from '@roolz/types/api/system'
import axios, { AxiosInstance } from 'axios'
import { retryRequest } from '../../utils/retryRequest'

export class SystemApi {
  identity: AxiosInstance
  identity2: AxiosInstance

  messaging: AxiosInstance
  hereProxy: AxiosInstance

  constructor(clients: ApiClients) {
    this.identity = clients.identity
    this.identity2 = clients.identity2

    this.messaging = clients.messaging
    this.hereProxy = clients.hereProxy
  }

  detectMyCountry() {
    return retryRequest(() => this.identity2.get('/v1/public/configuration/country/auto'), {
      attempts: 5
    })
  }

  getCountryList(locale?: string) {
    return retryRequest(() => this.identity2.get('/v1/public/configuration/country/list', {
      headers: {
        'Accept-Language': locale
      }
    }), {
      attempts: Infinity,
      delay: 1500
    })
  }

  checkNicknameBusyness(params: CheckNicknameBusynessRequest) {
    return this.identity2.get<CheckNicknameBusynessResponse>('/v1/public/profile/check_nickname', { params })
  }

  sendSms(body: SendSmsRequest) {
    return this.identity2.post<SendSmsResponse>('/v1/public/auth/login/phone/send_code', body)
  }
  sendSmsToChangePhone(body: SendSmsToChangePhoneRequest) {
    return this.identity2.post<SendSmsToChangePhoneResponse>('/v1/private/me/profile/update_auth_phone/send_code', body)
  }
  getClientConfig() {
    return this.identity2.get<ClientConfigResponse>('/v1/private/configuration/client_config')
  }
  getGeoPointsTimezone(params: {
    point: string[]
  }) {
    return this.hereProxy.get<PointsTimezonesResponse>('/mapgeo/v1/geo/timezone', {
      params
    })
  }
  sendEvent(body: SendEventRequest) {
    return this.identity.post('/v1/event/send', body)
  }

  // Proxying Next.js route with throttling
  sendSmsWithCaptcha(captchaToken: string, body: SendEventRequest) {
    return axios.post('/api/sms', body, {
      headers: { 'Verify-Token': captchaToken }
    })
  }
}
